import axios from "axios";
import { loadDecrypted } from "Common Usage/localStorageUtils";

export async function validateToken() {
  const token = loadDecrypted("HeartConnect-AuthToken");

  if (!token) return { valid: false, reason: "no_token" };
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/auth/validate-token`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return { valid: true };
  } catch (error) {
    if (error.response?.status === 401) {
      return {
        valid: false,
        reason: error.response.data?.message || "invalid",
      };
    }
    return { valid: false, reason: "network_error" };
  }
}
